export default __webpack_public_path__ + "static/media/041-waffles.824237ce.svg";